import React from 'react';

import { history } from 'ice';
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error({ error, info });
    console.log('error');
  }

  render() {
    if (this.state.hasError) {
      history.push('/mobile/home');
      // return <div>發生錯誤</div>;
    }

    return this.props.children;
  }
}
